export default __webpack_public_path__ + "static/media/heads-06.0a072dfc.svg";